"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Summary_1 = __importDefault(require("../entity/Summary"));
class SummaryStub extends Summary_1.default {
    constructor({ label = '2019/11', value = Math.floor(Math.random() * 100) } = {}) {
        super({
            label,
            value,
        });
    }
}
exports.default = SummaryStub;
